export default __webpack_public_path__ + "static/media/kalayana.66aa5bde.png";